import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

type Props = WidgetProps;

export interface BrandDetailContainerStyles {
    container?: InjectableCss;
}

export const brandDetailContainerStyles: BrandDetailContainerStyles = {
};

const styles = brandDetailContainerStyles;

const BrandDetailContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="BrandDetailContainer">
            <Hidden above="sm">
                <Zone contentId={id} zoneName="Content1" />
            </Hidden>
            <Hidden below="md">
                <Zone contentId={id} zoneName="Content2" />
            </Hidden>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailContainer,
    definition: {
        displayName: "Brand Detail Container",
        group: "Common",
    },
};

export default widgetModule;
